import { Suspense, lazy } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PageTransition } from "@/components/ui/page-transition";
import { LanguageProvider } from "@/contexts/LanguageContext";

// Lazy load non-critical UI components to reduce initial bundle
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const CustomCursor = lazy(() => import("@/components/ui/custom-cursor").then(m => ({ default: m.CustomCursor })));

// Eagerly load the home page for best LCP
import Home from "./pages/Home";

// Lazy load other routes to reduce initial bundle size
const ChooseModels = lazy(() => import("./pages/ChooseModels"));
const StartDesigning = lazy(() => import("./pages/StartDesigning"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Auth = lazy(() => import("./pages/Auth"));
const Profile = lazy(() => import("./pages/Profile"));
const TrackStatus = lazy(() => import("./pages/TrackStatus"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Suspense fallback={null}>
          <CustomCursor />
          <Toaster />
          <Sonner />
        </Suspense>
        <BrowserRouter>
          <PageTransition transition="fade">
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/choose-models" element={<ChooseModels />} />
                <Route path="/start-designing" element={<StartDesigning />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/track-status" element={<TrackStatus />} />
                <Route path="/admin" element={<AdminDashboard />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </PageTransition>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
